<template>
  <div
    :class="$style.container"
    :style="svgUrl"
  ></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { prepareCssValue } from '@/scripts/helpers/cssHelpers'

type BaseSvgPropsType = {
  path: string;
  width?: string | number;
  height?: string | number;
  size?: string | number;
  color?: string;
  actionable?: boolean;
}

const {
  path,
  width,
  height,
  size = 24,
  color = '',
  actionable = false
} = defineProps<BaseSvgPropsType>()

const svgUrl = computed(() => {
  const splittedPath = path.split('/')
  const svgLocation = `src/assets${splittedPath.length > 1 ? `/${splittedPath.slice(0, -1).join('/')}` : ''}`
  const svgName = splittedPath[splittedPath.length - 1]

  const svgUrl = new URL(`/${svgLocation}/${svgName}.svg`, import.meta.url).href

  return {
    [!!color ? 'maskImage' : 'backgroundImage']: `url(${svgUrl})`,
  }
})

const containerStyles = computed(() => {
  return {
    width: prepareCssValue(width || size),
    height: prepareCssValue(height || size),
    cursor: actionable ? 'pointer' : 'default'
  }
})
</script>

<style lang="scss" module>
.container {
  width: v-bind('containerStyles.width');
  height: v-bind('containerStyles.height');
  flex-shrink: 0;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
	background-color: v-bind(color);
  cursor: v-bind('containerStyles.cursor');
  transition: background-color 0.3s ease-out;
  @include flex-center-row();
}
</style>
